import moment from 'moment';
import { ConfigService } from '../../services/config/config.service';
import { TimeUtilities } from '../../utilities/time-utilities';
import { CustomInjector } from '../../services/custom-injector/custom-injector';
import { DateUtilities } from '../../utilities/date-utilities';

export class ODataOtherTaskNotificationModel {
    public NotificationType: string;
    public TaskCode: string;
    public ShortText: string;
    public ShowMatIcon: boolean;
    public PlannedDate: string;
    public PlannedStartTime: string;
    public EstimatedDuration: string;
    public Deadline: string;
    public NotificationNo: string;
    public Funcldescr: string;
    public Equidescr: string;
    public Equipment: string;
    public CanGetTask: boolean;
    public Customer: string;
    public TaskNo: string;
    public PlannedEndDate: string;
    public PlannedEndTime: string;
    public TaskStatus: string;
    public TaskCodeGrp: string;
    public DbNotifNo: string;
    public DbTaskNo: string;
    public DbNotifStatus: string;
    public DbNotifStartDate: string;
    public DbNotifStartTime: string;
    public DbNotifEndDate: string;
    public DbNotifEndTime: string;
    public FrontId: string;
}

export class OtherTaskNotificationModel {
    public readonly notificationType: string;
    public readonly taskCode: string;
    public readonly shortText: string;
    public readonly showMatIcon: boolean;
    public readonly plannedDate: moment.Moment;
    public readonly estimatedDuration: moment.Duration;
    public readonly deadline: string;
    public readonly notificationNo: string;
    public readonly funcldescr: string;
    public readonly equidescr: string;
    public readonly equipment: string;
    public canGetTask: boolean;
    public readonly customer: string;
    public readonly taskNo: string;
    public readonly taskStatus: string;
    public readonly taskCodeGrp: string;
    public readonly notifStatus: string;
    public readonly notifStartDate: string;
    public readonly notifStartTime: string;
    public readonly notifEndDate: string;
    public readonly notifEndTime: string;
    public readonly frontId: string;
    public readonly duration: string;
    private readonly formatMomentInUtc: boolean;

    public constructor(notification: ODataOtherTaskNotificationModel) {
        const injector = CustomInjector.getInjector();
        const configService = injector.get(ConfigService);
        this.formatMomentInUtc = configService.getFormatMomentInUTC();

        this.notificationType = notification.NotificationType;
        this.taskCode = notification.TaskCode;
        this.shortText = notification.ShortText;
        this.showMatIcon = notification.ShowMatIcon;
        this.duration = notification.EstimatedDuration;
        this.estimatedDuration = moment.duration(notification.EstimatedDuration, 'seconds');
        this.plannedDate = TimeUtilities.momentFromDateAndTime(
            notification.PlannedDate,
            notification.PlannedStartTime,
            this.formatMomentInUtc,
        );
        this.deadline = notification.Deadline;
        this.notificationNo = notification.NotificationNo;
        this.funcldescr = notification.Funcldescr;
        this.equidescr = notification.Equidescr;
        this.equipment = notification.Equipment;
        this.canGetTask = notification.CanGetTask;
        this.customer = notification.Customer;
        this.taskNo = notification.TaskNo;
        this.taskStatus = notification.TaskStatus;
        this.taskCodeGrp = notification.TaskCodeGrp;
        this.notifStatus = notification.DbNotifStatus;
        this.notifStartDate = notification.PlannedDate;
        this.notifStartTime = notification.PlannedStartTime;
        this.notifEndDate = notification.PlannedEndDate;
        this.notifEndTime = notification.PlannedEndTime;
        this.frontId = notification.FrontId;
    }

    public getDeadline(): string {
        return DateUtilities.formatDate(moment(this.deadline));
    }

    public getEstimatedTime(): string {
        return TimeUtilities.getFormattedDuration(this.estimatedDuration.hours(), this.estimatedDuration.minutes());
    }
}
